(() => {
  const selector = '[role="dialog"]:has(form.klaviyo-form)';
  const dismissed = 'colagea-popup-dismissed';
  let focusBeforeOpen = null;
  function recoverClosedDialogs() {
    const dialogs = [...document.querySelectorAll(selector)];
    let recovered = false;
    for (const dialog of dialogs) {
      const style = getComputedStyle(dialog);
      if (!style.animationName.includes('klaviyo-fadeout') || Number(style.opacity) > 0.01) continue;
      const heldFocus = dialog.contains(document.activeElement);
      dialog.classList.add(dismissed);
      dialog.inert = true;
      dialog.setAttribute('aria-hidden', 'true');
      recovered = true;
      if (heldFocus) {
        const target = focusBeforeOpen?.isConnected && !dialog.contains(focusBeforeOpen)
          ? focusBeforeOpen : document.querySelector('main h1');
        if (target instanceof HTMLElement) {
          if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
          target.focus({ preventScroll: true });
        }
      }
    }
    const openDialog = dialogs.some(dialog => !dialog.classList.contains(dismissed) && getComputedStyle(dialog).display !== 'none');
    if (recovered && !openDialog) document.body.classList.remove('klaviyo-prevent-body-scrolling');
  }
  window.addEventListener('klaviyoForms', event => {
    if (event.detail?.type === 'open') {
      focusBeforeOpen = document.activeElement;
      document.querySelectorAll(selector).forEach(dialog => {
        dialog.classList.remove(dismissed);
        dialog.inert = false;
        dialog.removeAttribute('aria-hidden');
      });
    }
    if (event.detail?.type === 'close') setTimeout(recoverClosedDialogs, 800);
  });
  document.addEventListener('click', event => {
    if (event.target instanceof Element && event.target.closest(selector)) {
      setTimeout(recoverClosedDialogs, 800);
    }
  }, true);
})();
